import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Briefcase, Users, Target, ClipboardCheck } from "lucide-react";

export function DestinationsNav() {
  return (
    <section className="py-8 border-t border-border/50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Link to="/services" className="block group">
            <Card className="p-4 text-center hover:bg-muted/50 transition-colors border-primary/20 group-hover:border-primary/40">
              <Briefcase className="h-6 w-6 mx-auto mb-2 text-primary" />
              <span className="text-sm font-medium text-foreground">Services Amazon</span>
            </Card>
          </Link>
          
          <Link to="/accompagnement-amazon" className="block group">
            <Card className="p-4 text-center hover:bg-muted/50 transition-colors border-primary/20 group-hover:border-primary/40">
              <Users className="h-6 w-6 mx-auto mb-2 text-primary" />
              <span className="text-sm font-medium text-foreground">Accompagnement Amazon</span>
            </Card>
          </Link>
          
          <Link to="/cas-clients" className="block group">
            <Card className="p-4 text-center hover:bg-muted/50 transition-colors border-primary/20 group-hover:border-primary/40">
              <Target className="h-6 w-6 mx-auto mb-2 text-primary" />
              <span className="text-sm font-medium text-foreground">Cas clients</span>
            </Card>
          </Link>
          
          <Link to="/audit" className="block group">
            <Card className="p-4 text-center hover:bg-muted/50 transition-colors border-primary/20 group-hover:border-primary/40">
              <ClipboardCheck className="h-6 w-6 mx-auto mb-2 text-primary" />
              <span className="text-sm font-medium text-foreground">Audit gratuit</span>
            </Card>
          </Link>
        </div>
        
        {/* Search intent links - discret */}
        <div className="mt-6 text-center">
          <div className="text-xs text-muted-foreground space-x-4">
            <Link to="/accompagnement-amazon" className="hover:text-foreground transition-colors">
              agence d'accompagnement Amazon
            </Link>
            <span>•</span>
            <Link to="/accompagnement-amazon" className="hover:text-foreground transition-colors">
              gestion de compte Amazon
            </Link>
            <span>•</span>
            <Link to="/accompagnement-amazon" className="hover:text-foreground transition-colors">
              accompagnement Seller Central
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}